import { useEffect, useRef, useState } from "react";
export const useOtpInput = ({ onTextChange }) => {
    const [text, setText] = useState("");
    const inputRef = useRef(null);
    const [focusedInputIndex, setFocusedInputIndex] = useState(text.length);
    useEffect(() => {
        setFocusedInputIndex(Math.min(text.length, 6));
    }, [text]);
    const handlePress = (index) => {
        setFocusedInputIndex(index);
        inputRef.current?.focus();
    };
    const handleTextChange = (value) => {
        const newText = text.substring(0, focusedInputIndex) + '' + text.substring(focusedInputIndex + 1);
        if (value.length < text.length) {
            setFocusedInputIndex((prevIndex) => Math.max(prevIndex - 1, 0));
            setText(value);
        }
        else if (!isNaN(parseInt(value))) {
            const tempChar = value[value.length - 1];
            if (focusedInputIndex < text.length) {
                // update the otp input box
                if (tempChar >= '0' && tempChar <= '9') {
                    const newText = text.substring(0, focusedInputIndex) + tempChar + text.substring(focusedInputIndex + 1);
                    setText(newText);
                    value = newText;
                    setFocusedInputIndex(Math.min(value.length, 6));
                }
            }
            else {
                if (tempChar >= '0' && tempChar <= '9') {
                    setText(value);
                    setFocusedInputIndex(Math.min(value.length, 6));
                }
            }
            onTextChange?.(value);
        }
    };
    const clear = () => {
        setText("");
    };
    return {
        models: { text, inputRef, focusedInputIndex },
        actions: { handlePress, handleTextChange, clear },
        forms: { setText },
    };
};
